/**
 * DisplayModes for Controls.
 * @hidden
 */
export enum DisplayModes {
    Display = 0,
    Edit = 1,
    Add = 2
}